(function() {
  if (!document.body || !document.body.classList.contains("primary-school-page")) {
    return;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function resolveScrollTargetId(raw) {
    var id = String(raw || "").trim();
    // Старые якоря в кэшированном HTML.
    if (id === "tuition") return "block12";
    if (id === "testimonials") return "block19_reviews";
    return id;
  }

  /** Логика аккордеонов: app/assets/builds/unified_accordion.js (подключить в layout раньше этого файла) */
  function initMiddleHighAccordionsUnified() {
    if (window.UnifiedAccordion && typeof window.UnifiedAccordion.initMiddleHighSchoolAccordions === "function") {
      window.UnifiedAccordion.initMiddleHighSchoolAccordions();
    }
  }

  function initSecondaryNavigation() {
    document.querySelectorAll(".secondary-nav-btn[data-scroll-target]").forEach(function(button) {
      button.addEventListener("click", function() {
        var target = document.getElementById(resolveScrollTargetId(button.dataset.scrollTarget));
        if (!target) return;

        var topBar = document.querySelector(".top_bar");
        var navBar = document.querySelector(".nav-bar");
        var offset = (topBar ? topBar.offsetHeight : 0) + (navBar ? navBar.offsetHeight : 0) + 20;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: top, behavior: "smooth" });
      });
    });
  }

  function initSecondaryHeaderMenu() {
    var navBar = document.querySelector(".nav-bar");
    var mobileMenuBtn = document.querySelector(".mobile-menu-btn");
    var iconsMenuBtn = document.getElementById("iconsMenuBtn");
    var dropdownItems = Array.prototype.slice.call(document.querySelectorAll(".nav-bar > ul > li.dropdown"));

    if (!navBar) return;

    function closeMenu() {
      navBar.classList.remove("mobile-menu-open");
      dropdownItems.forEach(function(item) {
        item.classList.remove("dropdown-open");
      });
      if (iconsMenuBtn && window.innerWidth <= 768) {
        iconsMenuBtn.classList.remove("hidden");
      }
    }

    if (mobileMenuBtn) {
      mobileMenuBtn.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        navBar.classList.toggle("mobile-menu-open");
      });
    }

    if (iconsMenuBtn) {
      iconsMenuBtn.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        navBar.classList.remove("nav-bar-scrolled");
        navBar.classList.add("mobile-menu-open");
        if (window.innerWidth <= 768) {
          iconsMenuBtn.classList.add("hidden");
        } else {
          iconsMenuBtn.classList.remove("visible");
        }
      });
    }

    dropdownItems.forEach(function(item) {
      var trigger = item.querySelector(":scope > a") || item.querySelector("a");
      var dropdownMenu = item.querySelector(".dropdown-menu");

      if (trigger) {
        trigger.addEventListener("click", function(event) {
          if (window.innerWidth > 1195) return;
          event.preventDefault();
          event.stopPropagation();
          var shouldOpen = !item.classList.contains("dropdown-open");
          dropdownItems.forEach(function(other) {
            if (other !== item) other.classList.remove("dropdown-open");
          });
          item.classList.toggle("dropdown-open", shouldOpen);
        });
      }

      if (dropdownMenu) {
        dropdownMenu.addEventListener("click", function(event) {
          var link = event.target.closest("a");
          if (window.innerWidth <= 1195 && link && dropdownMenu.contains(link)) {
            event.stopPropagation();
          }
        }, true);
      }
    });

    document.addEventListener("click", function(event) {
      if (mobileMenuBtn && mobileMenuBtn.contains(event.target)) return;
      if (iconsMenuBtn && iconsMenuBtn.contains(event.target)) return;
      if (navBar.contains(event.target)) return;
      closeMenu();
    });

    window.addEventListener("resize", function() {
      if (window.innerWidth > 1195) {
        closeMenu();
      }
    });
  }

  function initSecondaryRegionSelector() {
    var regionBtn = document.getElementById("regionBtn");
    var regionModal = document.getElementById("regionModal");
    var curCountry = document.getElementById("curCountry");
    var closeBtn = regionModal ? regionModal.querySelector(".close_btn") : null;
    var modalHeader = regionModal ? regionModal.querySelector(".modal_header") : null;
    var options = regionModal ? Array.prototype.slice.call(regionModal.querySelectorAll(".country_option")) : [];
    var STORAGE_KEY = "siteCountry";

    if (!regionBtn || !regionModal) return;

    function isUzbekistan(value) {
      var text = String(value || "").toLowerCase();
      return text.indexOf("узбек") >= 0 || text.indexOf("uzbek") >= 0;
    }

    function currentLanguage() {
      var savedLang = (window.localStorage && window.localStorage.getItem("siteLanguage")) || "";
      var htmlLang = String((document.documentElement && document.documentElement.lang) || "").trim();
      var pathLang = window.location.pathname.indexOf("/en-") >= 0 ? "en" : "ru";
      var lang = savedLang || htmlLang || pathLang;
      return String(lang).toLowerCase().indexOf("en") === 0 ? "en" : "ru";
    }

    function normalizeCountry(value) {
      var text = String(value || "").trim().toLowerCase();
      if (text === "uz" || text === "uzbekistan" || text === "узбекистан") return "uz";
      if (text === "ru" || text === "russia" || text === "россия" || text === "gb") return "ru";
      return isUzbekistan(text) ? "uz" : "ru";
    }

    function localizedCountryName(countryCode) {
      var lang = currentLanguage();
      if (countryCode === "uz") return lang === "en" ? "Uzbekistan" : "Узбекистан";
      return lang === "en" ? "Russia" : "Россия";
    }

    function modalText(countryCode) {
      var lang = currentLanguage();
      if (countryCode === "uz") {
        return lang === "en"
          ? "Your region was detected as Uzbekistan, you can change it to Russia."
          : "Ваш регион определился как Узбекистан, можете сменить его на Россию.";
      }
      return lang === "en"
        ? "Your region was detected as Russia, you can change it to Uzbekistan."
        : "Ваш регион определился как Россия, можете сменить его на Узбекистан.";
    }

    function currentCountryFromPath() {
      var m = window.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})(\/|$)/i);
      if (!m) return "ru";
      return m[1].toLowerCase() === "uz" ? "uz" : "ru";
    }

    function persistCountry(countryCode) {
      try {
        window.localStorage.setItem(STORAGE_KEY, normalizeCountry(countryCode));
      } catch (_error) {}
    }

    function targetPathFor(countryName) {
      var match = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
      if (!match) return window.location.pathname;

      var lang = match[1];
      var rest = match[3] || "/";
      var normalizedCountry = normalizeCountry(countryName);
      var targetCountry = normalizedCountry === "uz" ? "uz" : (lang === "en" ? "gb" : "ru");
      return "/" + lang + "-" + targetCountry + rest;
    }

    function applyRegionState(countryCode) {
      var normalized = normalizeCountry(countryCode);
      if (curCountry) curCountry.textContent = localizedCountryName(normalized);
      if (modalHeader) modalHeader.textContent = modalText(normalized);

      options.forEach(function(option) {
        var optionCountry = normalizeCountry(option.dataset.country || option.textContent);
        var isActive = optionCountry === normalized;
        option.classList.toggle("active", isActive);
        option.setAttribute("data-selected", isActive ? "true" : "false");
      });
    }

    function closeRegionModal() {
      regionModal.classList.remove("open");
      regionBtn.classList.remove("active");
    }

    regionBtn.addEventListener("click", function(event) {
      event.preventDefault();
      event.stopPropagation();
      var shouldOpen = !regionModal.classList.contains("open");
      closeRegionModal();
      if (shouldOpen) {
        regionModal.classList.add("open");
        regionBtn.classList.add("active");
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        closeRegionModal();
      });
    }

    options.forEach(function(option) {
      option.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        var countryCode = normalizeCountry(option.dataset.country || option.textContent);
        persistCountry(countryCode);
        // Как на главной/детсаду (saveRegion в regionSelector.js): cambridge_region + редирект. Иначе кука остаётся
        // со старым «Узбекистан», initRegionSelector сравнивает URL с cookie и откатывает ru-ru → ru-uz.
        if (typeof window.setCookie === "function" && window.COOKIE_NAME && window.COOKIE_DAYS) {
          var name = option.getAttribute("data-country") || (countryCode === "uz" ? "Узбекистан" : "Россия");
          var flag = option.getAttribute("data-flag") || "/kindergarten/src/icon/rf.webp";
          window.setCookie(window.COOKIE_NAME, JSON.stringify({ name: name, flag: flag }), window.COOKIE_DAYS);
        }
        applyRegionState(countryCode);
        window.location.href = targetPathFor(countryCode);
      });
    });

    document.addEventListener("click", function(event) {
      if (regionBtn.contains(event.target) || regionModal.contains(event.target)) return;
      closeRegionModal();
    });

    // Источник правды — URL: подстраиваем localStorage под текущий путь. Раньше preferred = saved || current
    // и при несовпадении шёл location.replace — при старом siteCountry=uz на странице ru-ru снова кидало на ru-uz
    // (цикл перезагрузок после смены региона UZ→RU).
    var currentCountry = currentCountryFromPath();
    persistCountry(currentCountry);
    applyRegionState(currentCountry);
  }

  function initSecondaryHeaderScroll() {
    var navBar = document.querySelector(".nav-bar");
    var topBar = document.querySelector(".top_bar");
    var iconsMenuBtn = document.getElementById("iconsMenuBtn");
    if (!navBar) return;

    var lastScrollTop = 0;

    function updateNavBarPosition() {
      if (!topBar) return;
      var topBarRect = topBar.getBoundingClientRect();
      var finalHeight = topBarRect.bottom > 0 ? topBarRect.bottom : (window.innerWidth >= 1196 ? 90 : 74);
      document.documentElement.style.setProperty("--top-bar-height", finalHeight + "px");
    }

    function updateNavBarVisibility() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var iconsContainer = iconsMenuBtn ? iconsMenuBtn.closest(".icons") : null;
      var contactsContainer = iconsContainer ? iconsContainer.closest(".contacts") : null;

      updateNavBarPosition();

      if (scrollTop > lastScrollTop && scrollTop > 10) {
        navBar.classList.add("nav-bar-scrolled");
        navBar.classList.remove("mobile-menu-open");
        if (iconsMenuBtn) {
          iconsMenuBtn.classList.remove("hidden");
          iconsMenuBtn.classList.add("visible");
        }
        if (iconsContainer) iconsContainer.classList.add("has-menu-btn");
        if (contactsContainer) contactsContainer.classList.add("has-menu-btn");
        if (topBar) topBar.classList.add("has-menu-btn");
      } else {
        navBar.classList.remove("nav-bar-scrolled");
        if (scrollTop <= 10) navBar.classList.remove("mobile-menu-open");
        if (iconsMenuBtn) {
          iconsMenuBtn.classList.add("hidden");
          iconsMenuBtn.classList.remove("visible");
        }
        if (iconsContainer) iconsContainer.classList.remove("has-menu-btn");
        if (contactsContainer) contactsContainer.classList.remove("has-menu-btn");
        if (topBar) topBar.classList.remove("has-menu-btn");
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    requestAnimationFrame(updateNavBarPosition);
    window.addEventListener("resize", function() {
      requestAnimationFrame(updateNavBarPosition);
    });
    window.addEventListener("load", function() {
      requestAnimationFrame(updateNavBarPosition);
    });
    window.addEventListener("scroll", updateNavBarVisibility, { passive: true });
    updateNavBarVisibility();
  }

  function initPreuniversityToggles() {
    document.querySelectorAll(".preuniversity__toggle").forEach(function(button) {
      var content = button.querySelector("[data-preu-content]");
      if (!content) return;

      var setOpen = function(isOpen) {
        button.classList.toggle("preuniversity__toggle--open", isOpen);
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
        content.hidden = !isOpen;
      };

      setOpen(false);

      button.addEventListener("click", function() {
        setOpen(!button.classList.contains("preuniversity__toggle--open"));
      });
    });
  }

  function initPreuniversitySelectors() {
    var btnIgcse = document.getElementById("preuniversityCtaIgcse");
    var modalIgcse = document.getElementById("preuniversityModalIgcse");
    var btnAlevel = document.getElementById("preuniversityCtaAlevel");
    var modalAlevel = document.getElementById("preuniversityModalAlevel");

    function closeAllPreuniversityModals() {
      [modalIgcse, modalAlevel].forEach(function(modal) {
        if (modal) modal.classList.remove("open");
      });
      [btnIgcse, btnAlevel].forEach(function(button) {
        if (!button) return;
        button.classList.remove("menu-open");
        button.setAttribute("aria-expanded", "false");
      });
    }

    if (btnIgcse && modalIgcse) {
      btnIgcse.addEventListener("click", function(event) {
        event.stopPropagation();
        var isOpen = modalIgcse.classList.contains("open");
        closeAllPreuniversityModals();
        if (!isOpen) {
          modalIgcse.classList.add("open");
          btnIgcse.classList.add("menu-open");
          btnIgcse.setAttribute("aria-expanded", "true");
        }
      });

      modalIgcse.querySelectorAll(".block14_campus_option").forEach(function(option) {
        option.addEventListener("click", function() {
          btnIgcse.textContent = option.textContent.trim();
          closeAllPreuniversityModals();
        });
      });
    }

    if (btnAlevel && modalAlevel) {
      btnAlevel.addEventListener("click", function(event) {
        event.stopPropagation();
        var isOpen = modalAlevel.classList.contains("open");
        closeAllPreuniversityModals();
        if (!isOpen) {
          modalAlevel.classList.add("open");
          btnAlevel.classList.add("menu-open");
          btnAlevel.setAttribute("aria-expanded", "true");
        }
      });

      modalAlevel.querySelectorAll(".block14_campus_option").forEach(function(option) {
        option.addEventListener("click", function() {
          btnAlevel.textContent = option.textContent.trim();
          closeAllPreuniversityModals();
        });
      });
    }

    /* Не вешаем глобальный document click, если блоков preuniversity нет — лишние обработчики на всей странице */
    if ((btnIgcse && modalIgcse) || (btnAlevel && modalAlevel)) {
      document.addEventListener("click", function() {
        closeAllPreuniversityModals();
      });
    }
  }

  function initSecondaryVideoSlider() {
    var wrapper = document.querySelector("[data-secondary-video-slider]");
    if (!wrapper) return;

    var cards = Array.from(wrapper.querySelectorAll(".background-block_video"));
    var prev = wrapper.querySelector(".video-slider-btn-prev");
    var next = wrapper.querySelector(".video-slider-btn-next");
    if (!cards.length) return;

    var activeIndex = 0;
    var transforms = [
      "translateX(0) scale(1)",
      "translateX(120px) scale(0.9)",
      "translateX(-110px) scale(0.9)"
    ];

    function stopAllVideos() {
      cards.forEach(function(card) {
        var video = card.querySelector("video");
        if (!video) return;
        video.pause();
        card.classList.remove("playing");
      });
    }

    function render() {
      cards.forEach(function(card, index) {
        var position = (index - activeIndex + cards.length) % cards.length;
        var video = card.querySelector("video");

        if (position === 0) {
          card.style.transform = transforms[0];
          card.style.opacity = "1";
          card.style.filter = "none";
          card.style.zIndex = "3";
          card.classList.add("active");
        } else if (position === 1) {
          card.style.transform = transforms[1];
          card.style.opacity = "0.72";
          card.style.filter = "blur(1px)";
          card.style.zIndex = "2";
          card.classList.remove("active");
        } else {
          card.style.transform = transforms[2];
          card.style.opacity = "0.72";
          card.style.filter = "blur(1px)";
          card.style.zIndex = "1";
          card.classList.remove("active");
        }

        if (video && !card.classList.contains("active")) {
          video.pause();
          card.classList.remove("playing");
        }
      });
    }

    function step(delta) {
      stopAllVideos();
      activeIndex = (activeIndex + delta + cards.length) % cards.length;
      render();
    }

    cards.forEach(function(card, index) {
      var video = card.querySelector("video");
      if (!video) return;

      card.addEventListener("click", function() {
        if (!card.classList.contains("active")) {
          activeIndex = index;
          stopAllVideos();
          render();
          return;
        }

        if (video.paused) {
          stopAllVideos();
          video.play().catch(function() {});
          card.classList.add("playing");
        } else {
          video.pause();
          card.classList.remove("playing");
        }
      });

      video.addEventListener("ended", function() {
        card.classList.remove("playing");
      });
    });

    if (prev) {
      prev.addEventListener("click", function(event) {
        event.stopPropagation();
        step(-1);
      });
    }

    if (next) {
      next.addEventListener("click", function(event) {
        event.stopPropagation();
        step(1);
      });
    }

    render();
  }

  function initSecondaryLeadForms() {
    var fallbackCountryCodes = [
      { code: "+7", country: "ru", name: "Russia", flag: "emoji", placeholder: "999 999 99 99", pattern: { min: 10, max: 10 } },
      { code: "+998", country: "uz", name: "Uzbekistan", flag: "emoji", placeholder: "99 999 99 99", pattern: { min: 9, max: 9 } },
      { code: "+1", country: "us", name: "United States", flag: "emoji", placeholder: "(999) 999-9999", pattern: { min: 10, max: 10 } },
      { code: "+1", country: "ca", name: "Canada", flag: "emoji", placeholder: "(999) 999-9999", pattern: { min: 10, max: 10 } },
      { code: "+20", country: "eg", name: "Egypt", flag: "emoji", placeholder: "100 123 4567", pattern: { min: 10, max: 10 } },
      { code: "+27", country: "za", name: "South Africa", flag: "emoji", placeholder: "82 123 4567", pattern: { min: 9, max: 9 } },
      { code: "+30", country: "gr", name: "Greece", flag: "emoji", placeholder: "691 234 5678", pattern: { min: 10, max: 10 } },
      { code: "+31", country: "nl", name: "Netherlands", flag: "emoji", placeholder: "6 12345678", pattern: { min: 9, max: 9 } },
      { code: "+32", country: "be", name: "Belgium", flag: "emoji", placeholder: "470 12 34 56", pattern: { min: 9, max: 9 } },
      { code: "+33", country: "fr", name: "France", flag: "emoji", placeholder: "6 12 34 56 78", pattern: { min: 9, max: 9 } }
    ];

    var campusMap = {
      skolkovo: { image: "/primary/img/Campus_1.webp", caption: "Кампус Сколково" },
      moscow: { image: "/primary/img/Campus_2.webp", caption: "Кампус Москва" },
      gorki: { image: "/primary/img/Campus_3.webp", caption: "Кампус Горки" },
      spb: { image: "/primary/img/Campus_4.webp", caption: "Кампус Санкт-Петербург" },
      tashkent: { image: "/primary/img/Campus_5.webp", caption: "Кампус Ташкент" }
    };

    function campusPreviewForOption(option, select) {
      if (option && option.dataset.image) {
        return { image: option.dataset.image, caption: option.dataset.caption || option.textContent };
      }

      var slug = option ? option.dataset.slug : "";
      if (slug && campusMap[slug]) return campusMap[slug];

      return campusMap[select && campusMap[select.value] ? select.value : "skolkovo"];
    }

    function isoToFlagEmoji(iso) {
      if (!iso || typeof iso !== "string") return "";
      var cc = iso.trim().toUpperCase();
      if (cc.length !== 2) return "";
      var base = "A".charCodeAt(0);
      return String.fromCodePoint(0x1F1E6 + (cc.charCodeAt(0) - base), 0x1F1E6 + (cc.charCodeAt(1) - base));
    }

    function ensureEmojiNode(trigger, flag) {
      var emoji = trigger.querySelector(".phoneFlagEmoji");
      if (!emoji) {
        emoji = document.createElement("span");
        emoji.className = "phoneFlagEmoji";
        if (flag && flag.parentNode) {
          flag.parentNode.insertBefore(emoji, flag.nextSibling);
        } else {
          trigger.insertBefore(emoji, trigger.firstChild);
        }
      }
      return emoji;
    }

    function setSelectorVisual(trigger, flag, iso, flagPath) {
      if (!trigger) return;
      trigger.dataset.selectedIso = iso || "";
      var existingFlagEmoji = trigger.querySelector(".flag-emoji");
      if (existingFlagEmoji) {
        existingFlagEmoji.textContent = isoToFlagEmoji(iso);
        existingFlagEmoji.style.display = "";
        var phoneFlagEmoji = trigger.querySelector(".phoneFlagEmoji");
        if (phoneFlagEmoji) phoneFlagEmoji.style.display = "none";
        if (flag) flag.style.display = "none";
        return;
      }

      var emoji = ensureEmojiNode(trigger, flag);
      if (flag && flagPath && flagPath !== "emoji") flag.src = flagPath;
      if (flag) flag.style.display = "none";
      if (emoji) {
        emoji.textContent = isoToFlagEmoji(iso);
        emoji.style.display = "inline-flex";
      }
    }

    function countryCodesData() {
      if (Array.isArray(window.countryCodesData) && window.countryCodesData.length) {
        window.countryCodesData = window.countryCodesData.map(function(country) {
          var fallback = fallbackCountryCodes.find(function(entry) {
            return entry.code === country.code && entry.country === country.country;
          });
          return fallback ? Object.assign({}, fallback, country) : country;
        });
        return window.countryCodesData;
      }

      window.countryCodesData = fallbackCountryCodes.slice();
      return window.countryCodesData;
    }

    function getCountryByCodeAndIso(code, iso) {
      return countryCodesData().find(function(country) {
        return country.code === code && (!iso || country.country === iso);
      }) || countryCodesData().find(function(country) {
        return country.code === code;
      }) || null;
    }

    function getCountryBySelector(selectorId) {
      var trigger = document.getElementById("phoneFlagSelector_" + selectorId);
      var code = document.getElementById("phoneCode_" + selectorId);
      if (!code) return null;
      return getCountryByCodeAndIso(code.textContent.trim(), trigger ? trigger.dataset.selectedIso : "");
    }

    function validatePhoneNumber(value, country) {
      if (!country || !country.pattern) return value.replace(/\D/g, "").length >= 6;
      var digits = value.replace(/\D/g, "");
      return digits.length >= country.pattern.min && digits.length <= country.pattern.max;
    }

    function formatPhoneNumber(value, country) {
      var digits = value.replace(/\D/g, "");
      if (!country || !country.pattern) return digits.replace(/(\d{3})(?=\d)/g, "$1 ");

      digits = digits.slice(0, country.pattern.max);
      if (country.code === "+7") {
        if (digits.length > 8) return digits.slice(0, 3) + " " + digits.slice(3, 6) + " " + digits.slice(6, 8) + " " + digits.slice(8);
        if (digits.length > 6) return digits.slice(0, 3) + " " + digits.slice(3, 6) + " " + digits.slice(6);
        if (digits.length > 3) return digits.slice(0, 3) + " " + digits.slice(3);
        return digits;
      }
      if (country.code === "+998") {
        if (digits.length > 7) return digits.slice(0, 2) + " " + digits.slice(2, 5) + " " + digits.slice(5, 7) + " " + digits.slice(7);
        if (digits.length > 5) return digits.slice(0, 2) + " " + digits.slice(2, 5) + " " + digits.slice(5);
        if (digits.length > 2) return digits.slice(0, 2) + " " + digits.slice(2);
        return digits;
      }
      if (country.code === "+1") {
        if (digits.length > 6) return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
        if (digits.length > 3) return "(" + digits.slice(0, 3) + ") " + digits.slice(3);
        return digits.length ? "(" + digits : "";
      }

      return digits.replace(/(\d{3})(?=\d)/g, "$1 ");
    }

    function bindPhoneFormatter(input, selectorId) {
      if (!input) return;

      function applyFormatting() {
        var country = getCountryBySelector(selectorId);
        if (!country) return;

        input.value = formatPhoneNumber(input.value, country);
        input.dataset.countryCode = country.code;
        if (country.placeholder) {
          input.placeholder = country.placeholder;
          input.dataset.correctPlaceholder = country.placeholder;
        }
      }

      input.addEventListener("input", applyFormatting);
      input.addEventListener("blur", applyFormatting);
      applyFormatting();
    }

    function isPhoneInputValid(input, selectorId) {
      if (!input) return false;
      return validatePhoneNumber(input.value || "", getCountryBySelector(selectorId));
    }

    function validateEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
    }

    function setFormSubmitting(form, isSubmitting) {
      if (!form) return;
      var submitButton = form.querySelector(".form_step2_submit");
      var loader = form.querySelector(".form_step2_loader");
      if (submitButton) submitButton.disabled = isSubmitting;
      if (loader) loader.style.display = isSubmitting ? "block" : "none";
      form.dataset.submitting = isSubmitting ? "true" : "false";
    }

    function syncPhoneCode(form) {
      if (!form) return;
      form.querySelectorAll('input[type="tel"][id^="phone_step2_"]').forEach(function(input) {
        var wrapper = input.closest(".phone_wrapper");
        var codeNode = wrapper ? wrapper.querySelector(".phone-code") : null;
        var hiddenNode = wrapper ? wrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
        if (codeNode && hiddenNode) hiddenNode.value = codeNode.textContent.trim();
      });
    }

    function submitSecondaryRequestForm(form) {
      if (!form || form.dataset.submitting === "true") return;

      syncPhoneCode(form);
      setFormSubmitting(form, true);

      var csrfToken =
        (document.querySelector('meta[name="csrf-token"]') || {}).content ||
        (form.querySelector('input[name="authenticity_token"]') || {}).value;

      fetch(form.action, {
        method: (form.method || "POST").toUpperCase(),
        body: new FormData(form),
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": csrfToken || "",
          "Accept": "text/javascript"
        },
        credentials: "same-origin"
      })
        .then(function(response) {
          return response.text().then(function(text) {
            if (!response.ok) throw new Error("Request failed: " + response.status);
            return text;
          });
        })
        .then(function(jsResponse) {
          var script = document.createElement("script");
          script.textContent = jsResponse;
          document.head.appendChild(script);
          document.head.removeChild(script);
        })
        .catch(function(error) {
          console.error(error);
          alert("Ошибка отправки формы. Попробуйте ещё раз.");
          setFormSubmitting(form, false);
        });
    }

    function checkAntibot(value, answer) {
      return String(parseInt(value, 10)) === String(answer);
    }

    function generateAntibot() {
      var num1 = Math.floor(Math.random() * 50) + 10;
      var num2 = Math.floor(Math.random() * num1);
      return { num1: num1, num2: num2, answer: num1 - num2 };
    }

    function updateAntibotLabel(label, template, antibot) {
      if (!label || !antibot) return;
      var questionTemplate = template || "Сколько будет {num1} - {num2}?";
      label.textContent = questionTemplate
        .replace("{num1}", antibot.num1)
        .replace("{num2}", antibot.num2);
    }

    function currentSecondaryLanguage(formStep1) {
      var form = formStep1 ? formStep1.closest("form") : null;
      var savedLang = (window.localStorage && window.localStorage.getItem("siteLanguage")) || "";
      var formLang = form ? String(form.dataset.lang || "").trim() : "";
      var htmlLang = String((document.documentElement && document.documentElement.lang) || "").trim();
      var pathLang = window.location.pathname.indexOf("/en-") >= 0 ? "en" : "ru";
      var lang = savedLang || formLang || htmlLang || pathLang;
      return String(lang).toLowerCase().indexOf("en") === 0 ? "en" : "ru";
    }

    function antibotTemplateFor(formStep1) {
      if (!formStep1) return "Сколько будет {num1} - {num2}?";
      var lang = currentSecondaryLanguage(formStep1);
      var template = lang === "en"
        ? formStep1.dataset.antibotTemplateEn
        : formStep1.dataset.antibotTemplateRu;
      return String(template || "").trim() || "Сколько будет {num1} - {num2}?";
    }

    function initialSelectorState() {
      var preferredIso = window.location.pathname.indexOf("-uz/") >= 0 ? "uz" : "ru";
      var preferredCountry = countryCodesData().find(function(entry) {
        return entry.country === preferredIso;
      }) || countryCodesData()[0] || { code: "+7", country: "ru", flag: "emoji", placeholder: "999 999 99 99" };

      return {
        code: preferredCountry.code,
        iso: preferredCountry.country,
        flag: preferredCountry.flag,
        placeholder: preferredCountry.placeholder || ""
      };
    }

    function pagePreferredSelectorState() {
      var curCountryEl = document.getElementById("curCountry");
      var curCountry = curCountryEl ? curCountryEl.textContent.trim().toLowerCase() : "";
      var preferredIso = curCountry.indexOf("узбек") >= 0 || curCountry.indexOf("uzbek") >= 0
        ? "uz"
        : (window.location.pathname.indexOf("-uz/") >= 0 ? "uz" : "ru");
      var preferredCountry = countryCodesData().find(function(entry) {
        return entry.country === preferredIso;
      }) || initialSelectorState();

      return {
        code: preferredCountry.code,
        iso: preferredCountry.country,
        flag: preferredCountry.flag,
        placeholder: preferredCountry.placeholder || ""
      };
    }

    function applySelectorState(selectorId, state) {
      var trigger = document.getElementById("phoneFlagSelector_" + selectorId);
      var code = document.getElementById("phoneCode_" + selectorId);
      var flag = document.getElementById("phoneFlagImg_" + selectorId);
      var phoneInput = document.getElementById("phone_" + selectorId) || document.getElementById("phone_step2_" + selectorId.replace(/^step2_/, ""));
      if (code) code.textContent = state.code;
      setSelectorVisual(trigger, flag, state.iso, state.flag);
      if (phoneInput && state.placeholder) {
        phoneInput.placeholder = state.placeholder;
        phoneInput.dataset.countryCode = state.code;
        phoneInput.dataset.correctPlaceholder = state.placeholder;
        phoneInput.value = formatPhoneNumber(phoneInput.value || "", getCountryByCodeAndIso(state.code, state.iso));
        var maxLength = (typeof window.getMaxFormattedLength === "function")
          ? window.getMaxFormattedLength(state.code)
          : state.placeholder.length;
        if (maxLength) phoneInput.setAttribute("maxlength", String(maxLength));
      }
    }

    function syncSelectorState(fromId, toId) {
      var fromTrigger = document.getElementById("phoneFlagSelector_" + fromId);
      var code = document.getElementById("phoneCode_" + fromId);
      var flag = document.getElementById("phoneFlagImg_" + fromId);
      if (!code || !flag) return;
      var selectedIso = fromTrigger ? fromTrigger.dataset.selectedIso : "";
      var country = countryCodesData().find(function(entry) {
        return entry.country === selectedIso || entry.code === code.textContent.trim();
      });
      applySelectorState(toId, {
        code: code.textContent.trim(),
        iso: country ? country.country : selectedIso,
        flag: flag.src,
        placeholder: country ? country.placeholder : ""
      });
    }

    function populatePhoneCountries(modal) {
      if (!modal) return;
      var container = modal.querySelector(".phone_country_options");
      if (!container) return;
      var countries = countryCodesData();
      if (!countries.length) return;

      container.innerHTML = "";
      countries.forEach(function(country) {
        var option = document.createElement("div");
        option.className = "phone_country_option";
        option.dataset.country = country.country;
        option.dataset.code = country.code;
        option.dataset.flag = country.flag;
        option.dataset.placeholder = country.placeholder || "";
        option.innerHTML = '<span class="flag-emoji" aria-hidden="true">' + isoToFlagEmoji(country.country) + '</span><span>' + country.code + "</span>";
        container.appendChild(option);
      });
    }

    function fitPhoneModalIntoViewport(trigger, modal) {
      if (!trigger || !modal) return;
      var wrapper = modal.closest(".phone_modal_wrapper");
      if (!wrapper) return;

      wrapper.style.left = "0";
      wrapper.style.right = "auto";
      wrapper.style.transform = "none";

      requestAnimationFrame(function() {
        var rect = modal.getBoundingClientRect();
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        var edgeGap = 12;
        var shiftX = 0;

        if (rect.right > viewportWidth - edgeGap) {
          shiftX -= (rect.right - (viewportWidth - edgeGap));
        }
        if (rect.left < edgeGap) {
          shiftX += (edgeGap - rect.left);
        }

        if (shiftX !== 0) {
          wrapper.style.transform = "translateX(" + shiftX + "px)";
        }
      });
    }

    function initPhoneSelector(selectorId) {
      var trigger = document.getElementById("phoneFlagSelector_" + selectorId);
      var modal = document.getElementById("phoneModal_" + selectorId);
      var code = document.getElementById("phoneCode_" + selectorId);
      var flag = document.getElementById("phoneFlagImg_" + selectorId);
      if (!trigger || !modal || !code || !flag) return;
      if (trigger.dataset.initialized === "true") return;

      populatePhoneCountries(modal);
      var currentCode = String(code.textContent || "").trim();
      var currentIso = String(trigger.dataset.selectedIso || "").trim();
      var currentCountry = currentCode ? getCountryByCodeAndIso(currentCode, currentIso) : null;
      var preferredState = pagePreferredSelectorState();
      applySelectorState(selectorId, currentCountry && currentCountry.country === preferredState.iso ? {
        code: currentCountry.code,
        iso: currentCountry.country,
        flag: currentCountry.flag,
        placeholder: currentCountry.placeholder || ""
      } : preferredState);

      trigger.addEventListener("click", function(event) {
        if (event.target.closest(".phone_country_option")) return;
        if (event.target.closest(".phone_close_btn")) return;
        event.stopPropagation();
        trigger.classList.toggle("active");
        modal.classList.toggle("open");
        if (modal.classList.contains("open")) fitPhoneModalIntoViewport(trigger, modal);
      });

      var closeBtn = modal.querySelector(".phone_close_btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", function(event) {
          event.stopPropagation();
          trigger.classList.remove("active");
          modal.classList.remove("open");
        });
      }

      modal.querySelectorAll(".phone_country_option").forEach(function(option) {
        option.addEventListener("click", function(event) {
          event.stopPropagation();
          var state = {
            code: option.dataset.code || code.textContent,
            iso: option.dataset.country || "",
            flag: option.dataset.flag || flag.src,
            placeholder: option.dataset.placeholder || ""
          };
          applySelectorState(selectorId, state);
          trigger.classList.remove("active");
          modal.classList.remove("open");
        });
      });
    }

    function getQuestionsSelectorNodes() {
      return {
        trigger: document.getElementById("phoneFlagSelector4"),
        modal: document.getElementById("phoneModal4"),
        code: document.getElementById("phoneCode4"),
        flag: document.getElementById("phoneFlagImg4"),
        input: document.getElementById("phone4")
      };
    }

    function getQuestionsSelectorCountry() {
      var nodes = getQuestionsSelectorNodes();
      if (!nodes.code) return null;
      return getCountryByCodeAndIso(nodes.code.textContent.trim(), nodes.trigger ? nodes.trigger.dataset.selectedIso : "");
    }

    function applyQuestionsSelectorState(state) {
      var nodes = getQuestionsSelectorNodes();
      if (nodes.code) nodes.code.textContent = state.code;
      setSelectorVisual(nodes.trigger, nodes.flag, state.iso, state.flag);
      if (nodes.input && state.placeholder) {
        nodes.input.placeholder = state.placeholder;
        nodes.input.dataset.countryCode = state.code;
        nodes.input.dataset.correctPlaceholder = state.placeholder;
        nodes.input.value = formatPhoneNumber(nodes.input.value || "", getCountryByCodeAndIso(state.code, state.iso));
        var maxLength = (typeof window.getMaxFormattedLength === "function")
          ? window.getMaxFormattedLength(state.code)
          : state.placeholder.length;
        if (maxLength) nodes.input.setAttribute("maxlength", String(maxLength));
      }
    }

    function initQuestionsPhoneSelector() {
      var nodes = getQuestionsSelectorNodes();
      if (!nodes.trigger || !nodes.modal || !nodes.code || !nodes.flag) return;

      populatePhoneCountries(nodes.modal);
      var currentCode = String(nodes.code.textContent || "").trim();
      var currentIso = String(nodes.trigger.dataset.selectedIso || "").trim();
      var currentCountry = currentCode ? getCountryByCodeAndIso(currentCode, currentIso) : null;
      var preferredState = pagePreferredSelectorState();
      applyQuestionsSelectorState(currentCountry && currentCountry.country === preferredState.iso ? {
        code: currentCountry.code,
        iso: currentCountry.country,
        flag: currentCountry.flag,
        placeholder: currentCountry.placeholder || ""
      } : preferredState);

      nodes.trigger.addEventListener("click", function(event) {
        if (event.target.closest(".phone_country_option")) return;
        if (event.target.closest(".phone_close_btn")) return;
        event.stopPropagation();
        nodes.trigger.classList.toggle("active");
        nodes.modal.classList.toggle("open");
        if (nodes.modal.classList.contains("open")) fitPhoneModalIntoViewport(nodes.trigger, nodes.modal);
      });

      var closeBtn = nodes.modal.querySelector(".phone_close_btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", function(event) {
          event.stopPropagation();
          nodes.trigger.classList.remove("active");
          nodes.modal.classList.remove("open");
        });
      }

      nodes.modal.querySelectorAll(".phone_country_option").forEach(function(option) {
        option.addEventListener("click", function(event) {
          event.stopPropagation();
          applyQuestionsSelectorState({
            code: option.dataset.code || nodes.code.textContent,
            iso: option.dataset.country || "",
            flag: option.dataset.flag || "emoji",
            placeholder: option.dataset.placeholder || ""
          });
          nodes.trigger.classList.remove("active");
          nodes.modal.classList.remove("open");
        });
      });
    }

    function initSecondaryQuestionsForm() {
      var form = document.getElementById("request_form_4");
      var phone = document.getElementById("phone4");
      var comment = document.getElementById("comment4");
      var nextButton = document.getElementById("submitBtn4");
      var step1 = form ? form.querySelector(".form_hover") : null;
      var step2 = document.getElementById("formStep2_4");
      var phoneStep2 = document.getElementById("phone_step2_4");
      var parentName = document.getElementById("parent_name_4");
      var email = document.getElementById("email_4");
      var birthDate = document.getElementById("birth_date_4");
      var campusSelect = document.getElementById("campus_4");
      var submitStep2 = document.getElementById("submitStep2_4");
      var phoneCodeField = document.getElementById("parent_phone_code_4");
      var campusImage = document.getElementById("campusImage_4");
      var campusCaption = document.getElementById("campusCaption_4");
      var campusImageDesktop = document.getElementById("campusImage_4_desktop");
      var campusCaptionDesktop = document.getElementById("campusCaption_4_desktop");
      var antibotLabel = document.getElementById("antibotLabel4");
      var antibot = generateAntibot();
      var lang = form && String(form.dataset.lang || "").toLowerCase().indexOf("en") === 0 ? "en" : "ru";
      var antibotTemplate = lang === "en" ? "What is {num1} minus {num2}?" : "Сколько будет {num1} минус {num2}?";

      if (!form || !phone || !comment || !nextButton || !step1 || !step2) return;

      initQuestionsPhoneSelector();
      initPhoneSelector("step2_4");
      updateAntibotLabel(antibotLabel, antibotTemplate, antibot);

      function formatQuestionsPhone() {
        var country = getQuestionsSelectorCountry();
        if (!country || !phone) return;
        phone.value = formatPhoneNumber(phone.value, country);
        phone.dataset.countryCode = country.code;
        if (country.placeholder) {
          phone.placeholder = country.placeholder;
          phone.dataset.correctPlaceholder = country.placeholder;
        }
      }

      function updateQuestionsCampus() {
        if (!campusSelect) return;
        var option = campusSelect.selectedOptions && campusSelect.selectedOptions[0];
        var campus = campusPreviewForOption(option, campusSelect);
        if (campusImage) campusImage.src = campus.image;
        if (campusCaption) campusCaption.textContent = campus.caption;
        if (campusImageDesktop) campusImageDesktop.src = campus.image;
        if (campusCaptionDesktop) campusCaptionDesktop.textContent = campus.caption;
      }

      function updateStep1State() {
        var country = getQuestionsSelectorCountry();
        var phoneValid = country ? validatePhoneNumber(phone.value || "", country) : false;
        nextButton.disabled = !(phoneValid && checkAntibot(comment.value.trim(), antibot.answer));
      }

      phone.addEventListener("input", function() {
        formatQuestionsPhone();
        updateStep1State();
      });
      phone.addEventListener("blur", formatQuestionsPhone);
      comment.addEventListener("input", updateStep1State);
      if (campusSelect) campusSelect.addEventListener("change", updateQuestionsCampus);

      formatQuestionsPhone();
      updateQuestionsCampus();
      updateStep1State();

      nextButton.addEventListener("click", function(event) {
        if (nextButton.disabled) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        step1.style.display = "none";
        step2.style.display = "flex";
        if (phoneStep2) phoneStep2.value = phone.value.trim();

        var country = getQuestionsSelectorCountry();
        if (country) {
          applySelectorState("step2_4", {
            code: country.code,
            iso: country.country,
            flag: country.flag || "emoji",
            placeholder: country.placeholder || ""
          });
        }
        if (phoneStep2) phoneStep2.value = formatPhoneNumber(phoneStep2.value || "", getCountryBySelector("step2_4"));
      });

      if (submitStep2) {
        submitStep2.addEventListener("click", function(event) {
          var missingFields = [];
          var isValid = true;

          if (!isPhoneInputValid(phoneStep2, "step2_4")) {
            if (phoneStep2) phoneStep2.classList.add("error");
            missingFields.push("Телефон");
            isValid = false;
          } else if (phoneStep2) {
            phoneStep2.classList.remove("error");
          }

          if (!parentName || !parentName.value.trim()) {
            if (parentName) parentName.classList.add("error");
            missingFields.push("Имя и фамилия родителя");
            isValid = false;
          } else if (parentName) {
            parentName.classList.remove("error");
          }

          if (!email || !validateEmail(email.value)) {
            if (email) email.classList.add("error");
            missingFields.push("Email");
            isValid = false;
          } else if (email) {
            email.classList.remove("error");
          }

          if (!campusSelect || !campusSelect.value) {
            if (campusSelect) campusSelect.classList.add("error");
            missingFields.push("Кампус");
            isValid = false;
          } else if (campusSelect) {
            campusSelect.classList.remove("error");
          }

          if (birthDate && birthDate.value.trim() && !/^\d{2}\.\d{2}\.\d{4}$/.test(birthDate.value.trim())) {
            birthDate.classList.add("error");
            missingFields.push("Дата рождения");
            isValid = false;
          } else if (birthDate) {
            birthDate.classList.remove("error");
          }

          if (!isValid) {
            event.preventDefault();
            alert("Пожалуйста, заполните обязательные поля: " + missingFields.join(", "));
            return;
          }

          if (phoneCodeField) {
            var step2Code = document.getElementById("phoneCode_step2_4");
            phoneCodeField.value = step2Code ? step2Code.textContent.trim() : "";
          }

          event.preventDefault();
          submitSecondaryRequestForm(form);
        });
      }

      if (email) {
        email.addEventListener("input", function() {
          if (validateEmail(email.value)) email.classList.remove("error");
        });
      }

      if (birthDate) {
        birthDate.addEventListener("input", function() {
          birthDate.classList.remove("error");
        });
      }

      if (parentName) {
        parentName.addEventListener("input", function() {
          parentName.classList.remove("error");
        });
      }
    }

    ["tour", "step2_tour", "consultation", "step2_consultation", "testing", "step2_testing"].forEach(initPhoneSelector);

    document.addEventListener("click", function() {
      document.querySelectorAll(".phone_flag_selector.active").forEach(function(trigger) {
        trigger.classList.remove("active");
      });
      document.querySelectorAll(".phone_modal.open").forEach(function(modal) {
        modal.classList.remove("open");
      });
    });

    document.querySelectorAll("[data-secondary-lead-form]").forEach(function(formStep1) {
      var formKey = formStep1.dataset.secondaryLeadForm;
      var antibot = generateAntibot();
      var phone = document.getElementById("phone_" + formKey);
      var comment = document.getElementById("comment_" + formKey);
      var nextButton = document.getElementById("submitBtn_" + formKey);
      var step2 = document.getElementById("formStep2_" + formKey);
      var phoneStep2 = document.getElementById("phone_step2_" + formKey);
      var parentName = document.getElementById("parent_name_" + formKey);
      var email = document.getElementById("email_" + formKey);
      var birthDate = document.getElementById("birth_date_" + formKey);
      var campusSelect = document.getElementById("campus_" + formKey);
      var submitStep2 = document.getElementById("submitStep2_" + formKey);
      var phoneCodeField = document.getElementById("parent_phone_code_" + formKey);
      var form = formStep1.closest("form");
      var campusImage = document.getElementById("campusImage_" + formKey);
      var campusCaption = document.getElementById("campusCaption_" + formKey);
      var campusImageDesktop = document.getElementById("campusImage_" + formKey + "_desktop");
      var campusCaptionDesktop = document.getElementById("campusCaption_" + formKey + "_desktop");
      var antibotLabel = document.getElementById("antibotLabel_" + formKey);

      if (!phone || !comment || !nextButton || !step2) return;

      bindPhoneFormatter(phone, formKey);
      bindPhoneFormatter(phoneStep2, "step2_" + formKey);
      updateAntibotLabel(antibotLabel, antibotTemplateFor(formStep1), antibot);

      function updateStep1State() {
        var valid = isPhoneInputValid(phone, formKey) && checkAntibot(comment.value.trim(), antibot.answer);
        nextButton.disabled = !valid;
      }

      function updateCampus() {
        if (!campusSelect) return;
        var option = campusSelect.selectedOptions && campusSelect.selectedOptions[0];
        var campus = option && option.dataset.image
          ? { image: option.dataset.image, caption: option.dataset.caption || option.textContent }
          : (campusMap[campusSelect.value] || campusMap.skolkovo);
        if (campusImage) campusImage.src = campus.image;
        if (campusCaption) campusCaption.textContent = campus.caption;
        if (campusImageDesktop) campusImageDesktop.src = campus.image;
        if (campusCaptionDesktop) campusCaptionDesktop.textContent = campus.caption;
      }

      phone.addEventListener("input", updateStep1State);
      comment.addEventListener("input", updateStep1State);
      updateStep1State();
      updateCampus();

      if (campusSelect) {
        campusSelect.addEventListener("change", updateCampus);
      }

      nextButton.addEventListener("click", function() {
        if (nextButton.disabled) return;
        formStep1.style.display = "none";
        step2.style.display = "flex";
        if (phoneStep2) phoneStep2.value = phone.value.trim();
        syncSelectorState(formKey, "step2_" + formKey);
        if (phoneStep2) phoneStep2.value = formatPhoneNumber(phoneStep2.value || "", getCountryBySelector("step2_" + formKey));
      });

      if (submitStep2) {
        submitStep2.addEventListener("click", function(event) {
          var missingFields = [];
          var isValid = true;
          var step2SelectorId = "step2_" + formKey;

          if (!isPhoneInputValid(phoneStep2, step2SelectorId)) {
            if (phoneStep2) phoneStep2.classList.add("error");
            missingFields.push("Телефон");
            isValid = false;
          } else if (phoneStep2) {
            phoneStep2.classList.remove("error");
          }

          if (!parentName || !parentName.value.trim()) {
            if (parentName) parentName.classList.add("error");
            missingFields.push("Имя и фамилия родителя");
            isValid = false;
          } else if (parentName) {
            parentName.classList.remove("error");
          }

          if (!email || !validateEmail(email.value)) {
            if (email) email.classList.add("error");
            missingFields.push("Email");
            isValid = false;
          } else if (email) {
            email.classList.remove("error");
          }

          if (!campusSelect || !campusSelect.value) {
            if (campusSelect) campusSelect.classList.add("error");
            missingFields.push("Кампус");
            isValid = false;
          } else if (campusSelect) {
            campusSelect.classList.remove("error");
          }

          if (birthDate && birthDate.value.trim() && !/^\d{2}\.\d{2}\.\d{4}$/.test(birthDate.value.trim())) {
            birthDate.classList.add("error");
            missingFields.push("Дата рождения");
            isValid = false;
          } else if (birthDate) {
            birthDate.classList.remove("error");
          }

          if (!isValid) {
            event.preventDefault();
            alert("Пожалуйста, заполните обязательные поля: " + missingFields.join(", "));
            return;
          }

          if (phoneCodeField) {
            var step2Code = document.getElementById("phoneCode_step2_" + formKey);
            phoneCodeField.value = step2Code ? step2Code.textContent.trim() : "";
          }
          event.preventDefault();
          submitSecondaryRequestForm(form);
        });
      }

      if (email) {
        email.addEventListener("input", function() {
          if (validateEmail(email.value)) email.classList.remove("error");
        });
      }

      if (birthDate) {
        birthDate.addEventListener("input", function() {
          birthDate.classList.remove("error");
        });
      }

      if (parentName) {
        parentName.addEventListener("input", function() {
          parentName.classList.remove("error");
        });
      }
    });

    initSecondaryQuestionsForm();
  }

  function initHorizontalSlider(slidesSelector, prevSelector, nextSelector) {
    var slides = document.querySelector(slidesSelector);
    var prev = document.querySelector(prevSelector);
    var next = document.querySelector(nextSelector);
    if (!slides) return;

    function amount() {
      var first = slides.firstElementChild;
      if (!first) return 300;
      return first.getBoundingClientRect().width + 16;
    }

    if (prev) {
      prev.addEventListener("click", function() {
        slides.scrollBy({ left: -amount(), behavior: "smooth" });
      });
    }

    if (next) {
      next.addEventListener("click", function() {
        slides.scrollBy({ left: amount(), behavior: "smooth" });
      });
    }
  }

  function initSecondaryReviewExpand() {
    return;
  }

  function initSecondaryCampusGallery() {
    if (typeof window.initInternalCampusGallerySlider === "function") {
      window.initInternalCampusGallerySlider();
    }
  }


  function initSecondaryTuition() {
    var section = document.querySelector("[data-secondary-tuition]");
    if (!section) return;

    var dataNode = section.querySelector("[data-secondary-tuition-prices]");
    var slides = section.querySelector("#block12PricesSlides");
    var campusBtn = section.querySelector("#block12CampusSelectorBtn");
    var campusModal = section.querySelector("#block12CampusModal");
    var yearBtn = section.querySelector("#block12YearSelectorBtn");
    var yearModal = section.querySelector("#block12YearModal");
    var selectedCampus = section.querySelector("#block12SelectedCampus");
    var selectedYear = section.querySelector("#block12SelectedYear");
    var campusImage = section.querySelector("#block12TextCampusImage");
    var campusCaption = section.querySelector("#block12TextCampusName");
    var moreLink = section.querySelector("#block12MoreLink");
    var infoTextNode = section.querySelector(".block12_price_info_text p");
    if (!dataNode || !slides || !campusBtn || !campusModal || !yearBtn || !yearModal || !selectedCampus || !selectedYear) return;

    var pricesData = {};
    try {
      pricesData = JSON.parse(dataNode.textContent || "{}");
    } catch (_error) {
      return;
    }

    var campusImages = {
      skolkovo: "/primary/img/Campus_1.webp",
      moscow: "/primary/img/Campus_2.webp",
      gorki: "/primary/img/Campus_3.webp",
      spb: "/primary/img/Campus_4.webp",
      tashkent: "/primary/img/Campus_5.webp"
    };
    var currentCampus = section.dataset.defaultCampus || "spb";
    var currentYear = section.dataset.currentYear || Object.keys(pricesData)[0];
    var infoTextHtml = infoTextNode ? infoTextNode.innerHTML : "";
    var moreLabel = moreLink ? moreLink.textContent.trim() : "";
    var infoLinkEl = section.querySelector("#block12TextCampusInfoLink");

    function tuitionFeesHref(campus, year) {
      var locale =
        (moreLink && moreLink.dataset && moreLink.dataset.locale) ||
        (infoLinkEl && infoLinkEl.dataset && infoLinkEl.dataset.locale) ||
        (window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\//) || ["/ru-ru/"])[0];
      return locale + "campuses/" + campus + "/tuition-fees/" + year + "/";
    }

    function campusName(campus) {
      var option = section.querySelector('.block12_campus_option[data-campus="' + campus + '"]');
      return option ? option.textContent.trim() : campus;
    }

    function yearLabel(year) {
      var option = section.querySelector('.block12_year_option[data-year="' + year + '"]');
      return option ? option.textContent.trim() : year;
    }

    function updateSelectedState() {
      selectedCampus.textContent = campusName(currentCampus);
      selectedYear.textContent = yearLabel(currentYear);

      section.querySelectorAll(".block12_campus_option").forEach(function(option) {
        var active = option.dataset.campus === currentCampus;
        option.classList.toggle("selected", active);
        option.classList.toggle("active", active);
      });

      section.querySelectorAll(".block12_year_option").forEach(function(option) {
        var active = option.dataset.year === currentYear;
        option.classList.toggle("selected", active);
        option.classList.toggle("active", active);
      });

      if (campusImage) campusImage.src = campusImages[currentCampus] || campusImage.src;
      if (campusCaption) campusCaption.textContent = campusName(currentCampus);
      if (moreLink) {
        moreLink.href = tuitionFeesHref(currentCampus, currentYear);
      }
    }

    function renderCards() {
      var cards = (pricesData[currentYear] && pricesData[currentYear][currentCampus]) || [];
      var cardsHtml = cards.map(function(card) {
        return [
          '<div class="block12_price_item" data-campus="', escapeHtml(currentCampus), '" data-category-id="', escapeHtml(card.category_id), '" style="display: flex;">',
          '<div class="block12_price_header">',
          '<div class="block12_price_title">', card.title || "", "</div>",
          '<div class="block12_price_subtitle">', escapeHtml(card.subtitle), "</div>",
          "</div>",
          '<div class="block12_price_age">',
          '<div class="block12_price_age_left">', escapeHtml(card.ages), "</div>",
          '<div class="block12_price_age_right">', escapeHtml(card.years), "</div>",
          "</div>",
          '<div class="block12_price_prices">',
          (card.prices || []).map(function(price) {
            return '<div class="block12_price_with"><div class="block12_price_with_discount">' + escapeHtml(price.amount) + "</div></div>";
          }).join(""),
          "</div>",
          "</div>"
        ].join("");
      }).join("");

      slides.innerHTML = cardsHtml + [
        '<div class="block12_price_item block12_price_info" data-campus="', escapeHtml(currentCampus), '" style="display: flex;">',
        '<div class="block12_price_info_content"><div class="block12_price_info_text"><p>', infoTextHtml, "</p></div></div>",
        '<div class="block12_price_info_buttons"><a href="', escapeHtml(tuitionFeesHref(currentCampus, currentYear)), '" class="block12_price_info_btn block12_price_info_btn_red" id="block12MoreLinkDynamic">', escapeHtml(moreLabel), "</a></div>",
        "</div>"
      ].join("");
    }

    function closeMenus() {
      campusModal.classList.remove("open");
      yearModal.classList.remove("open");
      campusBtn.classList.remove("menu-open");
      yearBtn.classList.remove("menu-open");
      campusBtn.setAttribute("aria-expanded", "false");
      yearBtn.setAttribute("aria-expanded", "false");
    }

    campusBtn.addEventListener("click", function(event) {
      event.stopPropagation();
      var shouldOpen = !campusModal.classList.contains("open");
      closeMenus();
      campusModal.classList.toggle("open", shouldOpen);
      campusBtn.classList.toggle("menu-open", shouldOpen);
      campusBtn.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
    });

    yearBtn.addEventListener("click", function(event) {
      event.stopPropagation();
      var shouldOpen = !yearModal.classList.contains("open");
      closeMenus();
      yearModal.classList.toggle("open", shouldOpen);
      yearBtn.classList.toggle("menu-open", shouldOpen);
      yearBtn.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
    });

    section.querySelectorAll(".block12_campus_option").forEach(function(option) {
      option.addEventListener("click", function(event) {
        event.stopPropagation();
        currentCampus = option.dataset.campus;
        updateSelectedState();
        renderCards();
        closeMenus();
      });
    });

    section.querySelectorAll(".block12_year_option").forEach(function(option) {
      option.addEventListener("click", function(event) {
        event.stopPropagation();
        currentYear = option.dataset.year;
        updateSelectedState();
        renderCards();
        closeMenus();
      });
    });

    document.addEventListener("click", function(event) {
      if (!section.contains(event.target)) closeMenus();
    });

    updateSelectedState();
    renderCards();
  }

  function initSecondaryContacts() {
    var section = document.querySelector("[data-secondary-contacts]");
    if (!section) return;

    var dataNode = section.querySelector("[data-secondary-contacts]");
    var selectorBtn = section.querySelector("#block20CampusSelectorBtn");
    var selectorModal = section.querySelector("#block20CampusModal");
    var selectorLabel = section.querySelector("#block20SelectedCampus");
    if (!dataNode || !selectorBtn || !selectorModal || !selectorLabel) return;

    var campuses = {};
    try {
      campuses = JSON.parse(dataNode.textContent || "{}");
    } catch (_error) {
      return;
    }

    var currentCampus = section.dataset.defaultCampus || "gorki";
    var map = null;
    var placemarks = [];
    var introMapTimer = null;
    var introMapZoomDone = false;

    function parseCoords(raw) {
      return String(raw || "").split(",").map(function(part) { return parseFloat(part.trim()); });
    }

    function cancelBlock20IntroZoom() {
      introMapZoomDone = true;
      if (introMapTimer) {
        clearTimeout(introMapTimer);
        introMapTimer = null;
      }
    }

    function applyCampus(campus, opts) {
      opts = opts || {};
      currentCampus = campus;
      var data = campuses[campus];
      if (!data) return;

      window.currentBlock20Campus = campus;

      // Синхронизируем выбор кампуса из блока контактов со всеми блоками страницы.
      // skipSync=true используем в колбэках глобальной синхронизации, чтобы не зациклиться.
      if (!opts.skipSync && typeof window.syncCampusSelection === "function") {
        window.syncCampusSelection(campus);
      }

      if (map && !opts.skipMap) {
        cancelBlock20IntroZoom();
      }

      selectorLabel.textContent = data.title;
      section.querySelectorAll(".block20_campus_option").forEach(function(option) {
        var active = option.dataset.campus === campus;
        option.classList.toggle("selected", active);
        option.classList.toggle("active", active);
      });

      var admissionsPhone = section.querySelector("#block20AdmissionsPhone");
      var secretaryEmail = section.querySelector("#block20SecretaryEmail");
      var secretaryPhones = section.querySelector("#block20SecretaryPhones");
      var contractsEmail = section.querySelector("#block20ContractsEmail");
      var contractsPhone = section.querySelector("#block20ContractsPhone");
      var addressValue = section.querySelector("#block20AddressValue");
      var coordinatesValue = section.querySelector("#block20CoordinatesValue");

      if (admissionsPhone) {
        admissionsPhone.href = data.admissions_href;
        admissionsPhone.textContent = data.admissions_phone;
      }
      if (secretaryEmail) {
        secretaryEmail.href = "mailto:" + data.secretary_email;
        secretaryEmail.textContent = data.secretary_email;
      }
      if (secretaryPhones) {
        secretaryPhones.innerHTML = (data.secretary_phones || []).map(function(phone) {
          return '<a href="tel:' + escapeHtml(String(phone).replace(/[^\d+]/g, "")) + '" class="block20_contact_value">' + escapeHtml(phone) + "</a>";
        }).join("");
      }
      if (contractsEmail) {
        contractsEmail.href = "mailto:" + data.contracts_email;
        contractsEmail.textContent = data.contracts_email;
      }
      if (contractsPhone) {
        contractsPhone.href = data.contracts_href;
        contractsPhone.textContent = data.contracts_phone;
      }
      if (addressValue) addressValue.textContent = data.address;
      if (coordinatesValue) coordinatesValue.textContent = data.coordinates;

      selectorModal.classList.remove("open");
      selectorBtn.classList.remove("menu-open");
      selectorBtn.setAttribute("aria-expanded", "false");

      if (map && data.center && !opts.skipMap) {
        map.setCenter(data.center, 15, { duration: 300, checkZoomRange: true });
      }
    }

    selectorBtn.addEventListener("click", function(event) {
      event.stopPropagation();
      var shouldOpen = !selectorModal.classList.contains("open");
      selectorModal.classList.toggle("open", shouldOpen);
      selectorBtn.classList.toggle("menu-open", shouldOpen);
      selectorBtn.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
    });

    section.querySelectorAll(".block20_campus_option").forEach(function(option) {
      option.addEventListener("click", function(event) {
        event.stopPropagation();
        applyCampus(option.dataset.campus);
      });
    });

    document.addEventListener("click", function(event) {
      if (!section.contains(event.target)) {
        selectorModal.classList.remove("open");
        selectorBtn.classList.remove("menu-open");
        selectorBtn.setAttribute("aria-expanded", "false");
      }
    });

    window.initSecondaryContactsMap = function initSecondaryContactsMap() {
      if (typeof ymaps === "undefined" || map) return;
      var mapNode = document.getElementById("block20_local_yandex_map");
      if (!mapNode) return;

      map = new ymaps.Map("block20_local_yandex_map", {
        center: [50.0, 50.0],
        zoom: 3,
        controls: ["zoomControl", "typeSelector", "fullscreenControl"],
        behaviors: ["default", "scrollZoom"]
      });

      Object.keys(campuses).forEach(function(campus) {
        var data = campuses[campus];
        if (!data || !data.center) return;
        var placemark = new ymaps.Placemark(parseCoords(data.coordinates), { hintContent: data.title }, {
          iconLayout: "default#image",
          iconImageHref: "/images/main/favicon.ico",
          iconImageSize: [46, 46],
          iconImageOffset: [-23, -46]
        });
        placemarks.push(placemark);
        map.geoObjects.add(placemark);
      });

      applyCampus(currentCampus, { skipMap: true });

      function runIntroZoom() {
        if (introMapZoomDone || !map) return;
        introMapZoomDone = true;
        var d = campuses[currentCampus];
        if (d && d.center) {
          map.setCenter(d.center, 15, { duration: 1000, checkZoomRange: true });
        }
      }

      function scheduleIntroZoom() {
        if (introMapZoomDone) return;
        introMapTimer = setTimeout(runIntroZoom, 2000);
      }

      window.cancelBlock20AutoZoom = function() {
        cancelBlock20IntroZoom();
      };

      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function(entries) {
          if (!entries[0] || !entries[0].isIntersecting) return;
          io.disconnect();
          scheduleIntroZoom();
        }, { threshold: 0.12, rootMargin: "100px 0px" });
        io.observe(mapNode);
      } else {
        scheduleIntroZoom();
      }
    };

    window.initBlock20LocalMap = window.initSecondaryContactsMap;

    if (typeof ymaps !== "undefined") {
      ymaps.ready(window.initSecondaryContactsMap);
    }

    window.updateCampusInfo = function(campusId) {
      if (!campuses[campusId]) return;
      applyCampus(campusId, { skipSync: true });
    };

    window.selectBlock20Campus = function(campusId, _updateMap) {
      if (!campuses[campusId]) return;
      applyCampus(campusId, { skipSync: true, skipMap: _updateMap === false });
    };

    applyCampus(currentCampus, { skipSync: true });
  }

  function initSecondaryStaff() {
    /* Fallback: если общий бандл уже инициализировал block14 через applyTeachers — не дублируем.
       Исключение: primary-school-page, тут селектор кампусов должен инициализироваться этим модулем. */
    if (
      document.querySelector("[data-landing-staff-js]") &&
      typeof window.applyTeachers === "function" &&
      !document.body.classList.contains("primary-school-page")
    ) return;

    var section = document.querySelector("[data-secondary-staff]");
    if (!section) return;

    var teachersJson = section.querySelector("[data-staff-teachers]");
    var reviewsJson = section.querySelector("[data-staff-reviews]");
    var teachersSlides = section.querySelector("#teachersSlides");
    var reviewsSlides = section.querySelector("#reviewsSlides");
    var reviewsSection = section.querySelector("#block14ReviewsSection");
    var preferredCampus = section.dataset.defaultCampus || "spb";
    var expandLabel = section.dataset.expandLabel || "Expand";
    var collapseLabel = section.dataset.collapseLabel || "Collapse";

    if (!teachersSlides || !reviewsSlides) return;

    var teachersByCampus = {};
    var reviewsByCampus = {};

    try {
      if (teachersJson && teachersJson.textContent) {
        teachersByCampus = JSON.parse(teachersJson.textContent || "{}");
      }
    } catch (_e) {
      teachersByCampus = {};
    }
    try {
      if (reviewsJson && reviewsJson.textContent) {
        reviewsByCampus = JSON.parse(reviewsJson.textContent || "{}");
      }
    } catch (_e) {
      reviewsByCampus = {};
    }
    var campusOrder = ["skolkovo", "moscow", "gorki", "spb", "tashkent"];
    var currentCampus =
      (teachersByCampus[preferredCampus] || reviewsByCampus[preferredCampus]) ? preferredCampus :
      campusOrder.find(function(campus) {
        return (teachersByCampus[campus] && teachersByCampus[campus].length) ||
          (reviewsByCampus[campus] && reviewsByCampus[campus].length);
      }) ||
      preferredCampus;

    function resetSliderPosition(container) {
      container.scrollLeft = 0;
      container.classList.remove("dragging", "scrolling");
      container.style.transform = "";
      container.style.transition = "";
    }

    function renderTeachers(campus) {
      var items = teachersByCampus[campus] || [];
      teachersSlides.innerHTML = items.map(function(item) {
        var name = escapeHtml(item.name);
        var position = escapeHtml(item.position);
        var image = escapeHtml(item.image || "/images/teachers/no_image.webp");

        return [
          '<article class="teacher_card">',
          '<img src="', image, '" alt="', name, '" class="teacher_photo" loading="lazy" />',
          '<div class="teacher_info">',
          '<div class="teacher_name">', name, "</div>",
          '<div class="teacher_position">', position, "</div>",
          "</div>",
          "</article>"
        ].join("");
      }).join("");

      resetSliderPosition(teachersSlides);
    }

    function renderReviews(campus) {
      var campusReviews = reviewsByCampus[campus];
      var items = Array.isArray(campusReviews) ? campusReviews : [];

      if (!items.length) {
        reviewsSlides.innerHTML = "";
        if (reviewsSection) reviewsSection.style.display = "none";
        return;
      }

      if (reviewsSection) reviewsSection.style.display = "";
      reviewsSlides.innerHTML = items.map(function(item) {
        var name = escapeHtml(item.name);
        var position = escapeHtml(item.position);
        var text = escapeHtml(item.text);
        var image = escapeHtml(item.image || "/images/teachers/no_image.webp");

        return [
          '<article class="review_card" itemscope itemtype="https://schema.org/Review">',
          '<div class="review_top">',
          '<img src="', image, '" alt="', name, '" class="review_avatar" loading="lazy" />',
          '<div class="review_header">',
          '<span class="review_name" itemprop="author" itemscope itemtype="https://schema.org/Person"><span itemprop="name">', name, "</span></span>",
          '<p class="review_position" itemprop="jobTitle">', position, "</p>",
          "</div>",
          "</div>",
          '<p class="review_text" itemprop="reviewBody">', text, "</p>",
          '<button class="review_expand" type="button">', expandLabel, "</button>",
          "</article>"
        ].join("");
      }).join("");

      resetSliderPosition(reviewsSlides);
    }

    function updateCampusLabels(campus) {
      section.querySelectorAll("#block14SelectedCampus, #block14SelectedCampusMobile").forEach(function(node) {
        var option = section.querySelector('.block14_campus_option[data-campus="' + campus + '"]');
        if (option) node.textContent = option.textContent.trim();
      });

      section.querySelectorAll(".block14_campus_option").forEach(function(option) {
        var active = option.dataset.campus === campus;
        option.classList.toggle("selected", active);
        option.classList.toggle("active", active);
      });
    }

    function closeCampusMenus() {
      section.querySelectorAll(".block14_campus_modal").forEach(function(modal) {
        modal.classList.remove("open");
      });
      section.querySelectorAll(".block14_campus_selector_btn").forEach(function(button) {
        button.classList.remove("menu-open");
        button.setAttribute("aria-expanded", "false");
      });
    }

    function applyCampus(campus) {
      currentCampus = campus;
      closeCampusMenus();
      if (typeof window.syncCampusSelection === "function") {
        window.syncCampusSelection(campus);
      } else {
        updateCampusLabels(campus);
        renderTeachers(campus);
        renderReviews(campus);
      }
    }

    section.querySelectorAll(".block14_campus_selector_wrapper").forEach(function(wrapper) {
      var button = wrapper.querySelector(".block14_campus_selector_btn");
      var modal = wrapper.querySelector(".block14_campus_modal");
      if (!button || !modal) return;

      button.addEventListener("click", function(event) {
        event.stopPropagation();
        var shouldOpen = !modal.classList.contains("open");
        closeCampusMenus();
        if (shouldOpen) {
          modal.classList.add("open");
          button.classList.add("menu-open");
          button.setAttribute("aria-expanded", "true");
        }
      });
    });

    section.querySelectorAll(".block14_campus_option").forEach(function(option) {
      option.addEventListener("click", function(event) {
        event.stopPropagation();
        applyCampus(option.dataset.campus);
      });
    });

    section.addEventListener("click", function(event) {
      var expandButton = event.target.closest(".review_expand");
      if (!expandButton) return;

      var card = expandButton.closest(".review_card");
      if (!card) return;

      event.preventDefault();
      card.classList.toggle("expanded");
      expandButton.textContent = card.classList.contains("expanded") ? collapseLabel : expandLabel;
    });

    document.addEventListener("click", function(event) {
      if (!section.contains(event.target)) closeCampusMenus();
    });

    initHorizontalSlider("#teachersSlides", "#teachersPrev", "#teachersNext");
    initHorizontalSlider("#reviewsSlides", "#reviewsPrev", "#reviewsNext");
    applyCampus(currentCampus);
  }

  function initAll() {
    initSecondaryHeaderMenu();
    initSecondaryRegionSelector();
    initSecondaryNavigation();
    initMiddleHighAccordionsUnified();
    initPreuniversityToggles();
    initPreuniversitySelectors();
    initSecondaryVideoSlider();
    initSecondaryLeadForms();
    initSecondaryStaff();
    initSecondaryTuition();
    initSecondaryCampusGallery();
    initSecondaryContacts();
    initHorizontalSlider("#parentReviewsSlides", "#parentReviewsPrev", "#parentReviewsNext");
    initHorizontalSlider("#studentReviewsSlides", "#studentReviewsPrev", "#studentReviewsNext");
    initHorizontalSlider("#mhArticlesSlides", "#mhArticlesPrev", "#mhArticlesNext");
    initSecondaryReviewExpand();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
